// 首页api接口
import axios from 'axios'

export default {
  // 精品课
  activeInfo: (config = {}) => axios.get(`activeInfo`, config),
  // 课程标准化-获取首页课程数据
  getHomeCourses: ({ provinceId, grade, subjectId }, config = {}) =>
    axios.get('https://online.xueersi.com/mall/home/courses', config),
  // 课程标准化-获取首页筛选
  getHomeSift: (config = {}) =>
    axios.get('https://online.xueersi.com/mall/home/sift', config)
}



// WEBPACK FOOTER //
// ./src/networks/api/IndexPage/index.js